<template>
<div>
  <section class="hero is-primary" id="head-section">
    <div class="hero-body">
      <div class="container has-text-centered">
        <h2 class="title">选择功能</h2>
      </div>
    </div>
  </section>

<ol>
  <li v-for="item in items" :key="item.pathName">
    <div class="box" @click="gotoPage(item.pathName)">{{ item.text }}</div>
  </li>
</ol>

<footer class="important-hint">
  <p style="text-align: center;">重要提示</p>
  <p>本计算工具基于您输入的数值按照标准平差算法得出计算结果，请合法使用本计算工具。我们不对计算结果承担任何责任。我们不会获悉或存储您输入的任何内容或计算结果，请自行备份。</p>
</footer>

</div>
</template>

<script>
export default {
  data () {
    return {
      items: [
        { pathName: 'hb', text: '输出手簿' },
        { pathName: 'ca', text: '平差计算' }
      ]
    }
  },
  methods: {
    gotoPage (pathName) {
      this.$router.push(pathName)
    }
  }
}
</script>

<style>
div.box {
  margin: 1em;
  text-align: center;
}

footer.important-hint {
  position: absolute;
  width: 100%;
  color: rgb(128, 128, 128);
  font-size: 0.5em;
  padding: 20px;
  bottom: 0;
}
</style>



// WEBPACK FOOTER //
// src/components/Home.vue